



// 'use client';

// import React, { useState, useEffect, useRef } from 'react';
// import { useSearchParams, useNavigate, useParams } from 'react-router-dom';
// import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
// import { Menu, X, Home, BarChart3, Users, Settings, LogOut, TrendingUp, DollarSign, Activity, UserPlus } from 'lucide-react';
// import Applications from './parentFolders/Applications';
// import Benefit from './parentFolders/Benefit';
// import GuarantorButton from '../GuarantorButton';
// import MyDetails from './parentFolders/MyDetails';
// import Profile from './parentFolders/Profile';
// import Search from './parentFolders/Search';
// import Notifications from './parentFolders/Notifications';
// import EmployeeDashboard from '../EmployeeDashboard';
// import EmployerEmployeeJobSeeker from '../EmployerEmployeeJobSeeker';
// import UrgentJobSeeker from './parentFolders/UrgentJobSeekerAccept';
// import Logo from "../../../assets/ejobs-logo.svg"
// import Homes from './parentFolders/Home';
// import { Link } from 'react-router-dom';
// import { BiSolidOffer } from 'react-icons/bi';
// import UserEngagementFeed from './parentFolders/FollowedJob';

// export default function JobSeekerDashboard() {
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [activeContent, setActiveContent] = useState('home');
//   const waveCanvasRef = useRef(null);
//   const { id } = useParams();    
//   const navigate = useNavigate();
//   const analyticsData = [
//     { name: 'Jan', revenue: 4000, users: 2400 },
//     { name: 'Feb', revenue: 3000, users: 1398 },
//     { name: 'Mar', revenue: 2000, users: 9800 },
//     { name: 'Apr', revenue: 2780, users: 3908 },
//     { name: 'May', revenue: 1890, users: 4800 },
//     { name: 'Jun', revenue: 2390, users: 3800 },
//   ];

 
//   const menuItems = [
//     { id: 'home', label: 'Home', icon: Home },
//     { id: 'analytics', label: 'Applied Jobs', icon: BarChart3 },
//     { id: 'benefits', label: 'Benefits', icon: BarChart3 },
//     { id: 'my-details', label: 'My Details', icon: BarChart3 },
//     { id: 'profile', label: 'My Profile', icon: BarChart3 },
//     { id: 'employee', label: 'My employee data', icon: BarChart3 },
//     { id: 'search', label: 'My Search', icon: BarChart3 },
//     { id: 'notifications', label: 'Notification', icon: BarChart3 },
//     // { id: 'users', label: 'Certified Jobseeker?', icon: Users },
//     { id: 'followed-Jobs', label: 'followed Jobs', icon: BiSolidOffer },
//   ];

//   // Water Wave Chart Animation
//   useEffect(() => {
//     const canvas = waveCanvasRef.current;
//     if (!canvas) return;

//     const ctx = canvas.getContext('2d');
//     let animationFrameId;
//     let phase = 0;

//     const totalActivity = 100; // Placeholder; will be updated dynamically in Home
//     const waveHeight = totalActivity > 0 ? Math.min(totalActivity * 0.5, 100) : 10;

//     const drawWave = () => {
//       ctx.clearRect(0, 0, canvas.width, canvas.height);
//       ctx.fillStyle = 'rgba(249, 115, 22, 0.2)'; // orange-500
//       ctx.beginPath();
//       ctx.moveTo(0, canvas.height);

//       for (let x = 0; x < canvas.width; x++) {
//         const y = canvas.height / 2 + Math.sin(x * 0.02 + phase) * 20;
//         ctx.lineTo(x, y - waveHeight);
//       }

//       ctx.lineTo(canvas.width, canvas.height);
//       ctx.closePath();
//       ctx.fill();

//       const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
//       gradient.addColorStop(0, 'rgba(249, 115, 22, 0.5)');
//       gradient.addColorStop(1, 'rgba(249, 115, 22, 0.1)');
//       ctx.fillStyle = gradient;
//       ctx.fill();

//       phase += 0.05;
//       animationFrameId = requestAnimationFrame(drawWave);
//     };

//     drawWave();
//     return () => cancelAnimationFrame(animationFrameId);
//   }, []);

//   const renderContent = () => {
//     switch (activeContent) {
//       case 'home':
//         return <Homes waveCanvasRef={waveCanvasRef} />;
//       case 'analytics':
//         return <Applications />;
//       case 'users':
//         return <UrgentJobSeeker />;
//       case 'benefits':
//         return <Benefit />;
//       case 'my-details':
//         return <MyDetails />;
//       case 'profile':
//         return <Profile />;
//       case 'search':
//         return <Search />;
//       case 'employee':
//         return <EmployerEmployeeJobSeeker />;
//       case 'notifications':
//         return <Notifications />;
//       case 'followed-Jobs':
//         return <UserEngagementFeed />
//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="flex h-screen bg-gray-100 dark:bg-gray-900">
//       {/* Sidebar */}
//       {/* <aside className={`${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0 scroll-y h-screen md:static inset-y-0 left-0 z-50 w-64 bg-[#F97316] text-white transition-transform duration-300 ease-in-out`}> */}
//       <aside
//   className={`
//     ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} 
//     md:translate-x-0 
//     fixed md:static 
//     inset-y-0 left-0 z-50 
//     w-64 bg-[#F97316] text-white 
//     transition-transform duration-300 ease-in-out
//     min-h-screen
//     overflow-y-auto
//   `}
// >

//         <div className="flex items-center justify-between p-6 border-b border-orange-600">
//        <Link to="/" className="flex-shrink-0">
//                   <img
//                     src={Logo}
//                     alt="Essential Jobs Nigeria"
//                     className="h-8 sm:h-10 w-auto bg-white rounded-sm p-50"
//                   />
//                 </Link>
//           {/* <h1 className="text-2xl font-bold">Dashboard</h1> */}
//           <button
//             onClick={() => setSidebarOpen(false)}
//             className="md:hidden text-white hover:text-orange-200"
//           >
//             <X className="w-6 h-6" />
//           </button>
//         </div>
//         <nav className="flex-1 p-4">
//           <ul className="space-y-2">
//             {menuItems.map((item) => {
//               const Icon = item.icon;
//               return (
//                 <li key={item.id}>
//                   <button
//                     onClick={() => {
//                       setActiveContent(item.id);
//                       setSidebarOpen(false);
//                     }}
//                     className={`w-full flex items-center p-3 rounded-lg transition ${
//                       activeContent === item.id
//                         ? 'bg-white text-orange-500 shadow-lg'
//                         : 'hover:bg-orange-600'
//                     }`}
//                   >
//                     <Icon className="w-5 h-5 mr-3" />
//                     {item.label}
//                   </button>
//                 </li>
//               );
//             })}
//           </ul>
//         </nav>
    
//       </aside>

//       {/* Main Content */}
//       <div className="flex-1 flex flex-col">
//         {/* Header */}
//         <header className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
//           <div className="flex items-center justify-between p-4">
//             <button
//               onClick={() => setSidebarOpen(true)}
//               className="md:hidden text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100"
//             >
//               <Menu className="w-6 h-6" />
//             </button>
//             <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 capitalize">{activeContent}</h2>
//                 <div className="">
//                 <Link to="/signin">
//                     <button className="w-full flex items-center p-3 rounded-lg hover:bg-orange-600 transition">
//             <LogOut className="w-5 mr-3" />
//             Logout
//           </button>

//                 </Link>
      
//         </div>
//           </div>
//         </header>

//         {/* Page Content */}
//         <main className="flex-1 p-6 overflow-y-auto bg-gray-100 dark:bg-gray-900">
//           {renderContent()}
//         </main>
//       </div>

//       {/* Mobile overlay */}
//       {sidebarOpen && (
//         <div
//           className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
//           onClick={() => setSidebarOpen(false)}
//         />
//       )}
//     </div>
//   );
// }





















'use client';

import React, { useState, useEffect, useRef } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { 
  BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, 
  Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell 
} from 'recharts';

import { 
  Menu, X, Home, BarChart3, Users, Settings, LogOut, 
  TrendingUp, DollarSign, Activity, UserPlus 
} from 'lucide-react';

import { BiSolidOffer } from 'react-icons/bi';

// Import your sub-components
import Homes from './parentFolders/Home';
import Applications from './parentFolders/Applications';
import Benefit from './parentFolders/Benefit';
import MyDetails from './parentFolders/MyDetails';
import Profile from './parentFolders/Profile';
import Search from './parentFolders/Search';
import Notifications from './parentFolders/Notifications';
import EmployerEmployeeJobSeeker from '../EmployerEmployeeJobSeeker';
import UserEngagementFeed from './parentFolders/FollowedJob';
import { Link } from 'react-router-dom';
import Logo from "../../../assets/ejobs-logo.svg";

export default function JobSeekerDashboard() {
  const { id } = useParams();                    // Get :id from /profile/:id
  const [searchParams, setSearchParams] = useSearchParams();
  
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const waveCanvasRef = useRef(null);

  // Get active tab from URL query parameter, default to 'home'
  const activeContent = searchParams.get('tab') || 'home';

  // Analytics data (you can make this dynamic later)
  const analyticsData = [
    { name: 'Jan', revenue: 4000, users: 2400 },
    { name: 'Feb', revenue: 3000, users: 1398 },
    { name: 'Mar', revenue: 2000, users: 9800 },
    { name: 'Apr', revenue: 2780, users: 3908 },
    { name: 'May', revenue: 1890, users: 4800 },
    { name: 'Jun', revenue: 2390, users: 3800 },
  ];

  const menuItems = [
    { id: 'home', label: 'Home', icon: Home },
    { id: 'analytics', label: 'Applied Jobs', icon: BarChart3 },
    { id: 'benefits', label: 'Benefits', icon: BarChart3 },
    { id: 'my-details', label: 'My Details', icon: BarChart3 },
    { id: 'profile', label: 'My Profile', icon: BarChart3 },
    { id: 'employee', label: 'My Employee Data', icon: BarChart3 },
    { id: 'search', label: 'My Search', icon: BarChart3 },
    { id: 'notifications', label: 'Notifications', icon: BarChart3 },
    { id: 'followed-Jobs', label: 'Followed Jobs', icon: BiSolidOffer },
  ];

  // Water Wave Canvas Animation
  useEffect(() => {
    const canvas = waveCanvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    let animationFrameId;
    let phase = 0;

    const drawWave = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      // First wave layer
      ctx.fillStyle = 'rgba(249, 115, 22, 0.2)';
      ctx.beginPath();
      ctx.moveTo(0, canvas.height);

      for (let x = 0; x < canvas.width; x++) {
        const y = canvas.height / 2 + Math.sin(x * 0.02 + phase) * 20;
        ctx.lineTo(x, y - 40); // wave height
      }

      ctx.lineTo(canvas.width, canvas.height);
      ctx.closePath();
      ctx.fill();

      // Gradient overlay
      const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
      gradient.addColorStop(0, 'rgba(249, 115, 22, 0.5)');
      gradient.addColorStop(1, 'rgba(249, 115, 22, 0.1)');
      ctx.fillStyle = gradient;
      ctx.fill();

      phase += 0.05;
      animationFrameId = requestAnimationFrame(drawWave);
    };

    drawWave();

    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  const handleMenuClick = (tabId) => {
    setSearchParams({ tab: tabId });
    setSidebarOpen(false); // Close mobile sidebar
  };

  const renderContent = () => {
    switch (activeContent) {
      case 'home':
        return <Homes waveCanvasRef={waveCanvasRef} />;
      case 'analytics':
        return <Applications />;
      case 'benefits':
        return <Benefit />;
      case 'my-details':
        return <MyDetails />;
      case 'profile':
        return <Profile />;
      case 'employee':
        return <EmployerEmployeeJobSeeker />;
      case 'search':
        return <Search />;
      case 'notifications':
        return <Notifications />;
      case 'followed-Jobs':
        return <UserEngagementFeed />;
      default:
        return <Homes waveCanvasRef={waveCanvasRef} />;
    }
  };

  // Get current tab label for header
  const currentTabLabel = menuItems.find(item => item.id === activeContent)?.label || 'Home';

  return (
    <div className="flex h-screen bg-gray-100 dark:bg-gray-900">
      {/* Sidebar */}
      <aside
        className={`
          ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} 
          md:translate-x-0 
          fixed md:static inset-y-0 left-0 z-50 
          w-64 bg-[#F97316] text-white 
          transition-transform duration-300 ease-in-out
          min-h-screen overflow-y-auto
        `}
      >
        <div className="flex items-center justify-between p-6 border-b border-orange-600">
          <Link to="/" className="flex-shrink-0">
            <img
              src={Logo}
              alt="Essential Jobs Nigeria"
              className="h-8 sm:h-10 w-auto bg-white rounded-sm p-1"
            />
          </Link>

          <button
            onClick={() => setSidebarOpen(false)}
            className="md:hidden text-white hover:text-orange-200"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <nav className="flex-1 p-4">
          <ul className="space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = activeContent === item.id;

              return (
                <li key={item.id}>
                  <button
                    onClick={() => handleMenuClick(item.id)}
                    className={`w-full flex items-center p-3 rounded-lg transition-all ${
                      isActive
                        ? 'bg-white text-orange-500 shadow-lg font-medium'
                        : 'hover:bg-orange-600'
                    }`}
                  >
                    <Icon className="w-5 h-5 mr-3" />
                    {item.label}
                  </button>
                </li>
              );
            })}
          </ul>
        </nav>
      </aside>

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <header className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center justify-between p-4">
            <button
              onClick={() => setSidebarOpen(true)}
              className="md:hidden text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100"
            >
              <Menu className="w-6 h-6" />
            </button>

            <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 capitalize">
              {currentTabLabel}
            </h2>

            <Link to="/signin">
              <button className="flex items-center gap-2 px-4 py-2 rounded-lg hover:bg-orange-50 dark:hover:bg-gray-700 transition">
                <LogOut className="w-5 h-5" />
                <span>Logout</span>
              </button>
            </Link>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 p-6 overflow-y-auto bg-gray-100 dark:bg-gray-900">
          {renderContent()}
        </main>
      </div>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
}